import React from 'react'
import { PurchasOptionsType } from '~/api/services/climaProgram'
import PurchaseFields from './PurchaseFields'
import FeedingFields from './FeedingFields'
import ReceiptUploadSection from './ReceiptUploadSection'
import AnimalGroupsFields from './AnimalGroupsFields'
import { useFormContext, useWatch } from 'react-hook-form'

interface Props {
  options: PurchasOptionsType
}

const FormPart: React.FC<Props> = ({ options }) => {
  const { control } = useFormContext()
  const watchAnimalGroup = useWatch({ control, name: 'animalGroup' })
  
  return (
    <>
      <PurchaseFields options={options} />
      <ReceiptUploadSection />
      <FeedingFields />
      {watchAnimalGroup && <AnimalGroupsFields options={options} />}
    </>
  )
}

export default FormPart
